import paronApi from '@/utils/paron-api'

export default {
    getAllMembers(page) {
        var path = page ? `member/all?page=${page}&per_page=10` : 'member/all'
        return paronApi.get(path)
    },
    getMemberById(id) {
        return paronApi.get(`member/${id}`)
    },

    createMember(data) {
        return paronApi.post('member/new', data)
    },

    editMemberById(id, data) {
        return paronApi.post(`member/${id}/edit`, data)
    },

    deleteMemberById(id) {
        return paronApi.delete(`member/${id}`)
    },
    getMembersByFilter(page, filter, sortOption, order, perPage = 100) {
        var path = `member/filtered?page=${page || 1}&per_page=${perPage}`
        if (sortOption) {
            path += `&sortOption=${sortOption}&order=${order || 'ASC'}`
        }
        return paronApi.post(path, filter)
    },
    // for autocompletes: a number is looked up as a card number, anything else as a name
    searchMembers(query) {
        const filter = /^\d+$/.test(query) ? { card: query } : { member: query }
        return this.getMembersByFilter(1, filter, null, null, 20).then(resp => resp.data.data)
    },
    toggleApproved(id) {
        return paronApi.post(`member/${id}/toggleApprove`)
    },
    // with dryRun the file is only checked: the response shows what the upload would do
    importFromFile(formData, dryRun = false) {
        return paronApi.uploadFile(`member/upload${dryRun ? '?dryRun=1' : ''}`, formData)
    },
    getMembersPhones() {
        return paronApi.download('member/phones.csv', null, 'GET')
    },
    getMembersEmails() {
        return paronApi.download('member/emails.csv', null, 'GET')
    },
    exportMembers(filter, sortOption, order) {
        const query = sortOption ? `?sortOption=${sortOption}&order=${order || 'ASC'}` : ''
        return paronApi.download(`member/export${query}`, filter)
    }

}
